import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { userRequest } from '../../../utils/requestMethods';
import { Header, CustomPagination, SkeletonTable } from '../../../components';
import { useStateContext } from '../../../contexts/ContextProvider';
import { MdSearch } from 'react-icons/md';
import { FiUsers } from 'react-icons/fi';

const customStyles = {
  headRow: {
    style: {
      backgroundColor: 'rgb(248, 250, 252)',
      fontWeight: "bold",
    },
  },
};

const TeacherSubjects = ({ history }) => {
  const { user, school } = useStateContext();
  const [subjects, setSubjects] = useState([]);
  //const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState('');

  const fetchSubjects = async () => {
    setLoading(true);
    try {
      const { data } = await userRequest.get(`/teachers/teacher-assigned-subjects/${school?._id}/${user?._id}?limit=100`);
      console.log(data);
      setSubjects(data.subjects || []);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      setSubjects([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, [school?._id, user?._id]);
  
  const columns = [
    {
      name: "Subject Name",
      selector: row => row.subject_name
    },
    {
      name: "Subject Code",
      selector: row => row.subject_code
    },
    {
      name: "Class",
      selector: row => row.class?.class_name || 'N/A',
    },
    {
      name: "Teacher Role",
      selector: row => {
        const role = row.teacher_role || 'N/A';
        return (
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${
            role === 'primary' 
              ? 'bg-indigo-100 text-indigo-800'
              : role === 'assistant'
              ? 'bg-purple-100 text-purple-800'
              : 'bg-gray-100 text-gray-800'
          }`}>
            {role === 'primary' ? 'Primary Teacher' : role === 'assistant' ? 'Assistant Teacher' : 'Teacher'}
          </span>
        );
      },
    },
    {
      name: "Lesson Notes",
      selector: row => row.lesson_notes_count || 0,
    },
    {
      name: 'Action',
      cell: (row) => (
        <button
          onClick={() => {
            if (row.class?._id) {
              history.push({ 
                pathname: `/t/subjects/notes/${row._id}/${row.class._id}`, 
                state: { subject: row } 
              });
            }
          }}
          disabled={!row.class?._id}
          className="inline-flex items-center px-4 py-2 bg-blue-800 hover:bg-blue-700 text-white text-xs font-semibold rounded-full transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
          title="View Details"
        >
          View Details
        </button>
      ),
      ignoreRowClick: true,
    },
  ];

  const filteredData = subjects?.filter((item) =>
    (item.subject_name?.toLowerCase().includes(filterText.toLowerCase()) || '') ||
    (item.class?.class_name?.toLowerCase().includes(filterText.toLowerCase()) || '')
  );

  return (
    <>
    <div className="px-3 md:px-10 pt-10 md:pt-5 mt-10">
      <div className="flex flex-wrap justify-between items-center mb-4">
        <Header category="Subjects" title="Assigned Lesson" />
      </div>
    </div>

    <div className="m-2 md:mx-10 p-4 md:p-10 bg-white rounded-3xl dark:bg-secondary-dark-bg min-h-screen">
      <div className="flex flex-wrap justify-between items-center mb-4">
        <h1 className="text-lg font-semibold w-full md:w-auto mb-2 md:mb-0" style={{ maxWidth: "20em" }}>
          Subject Details
        </h1>
        <div className="flex flex-wrap justify-center md:justify-end w-full md:w-auto gap-2">
          {/* Search Input */}
          <form className="w-full md:w-auto">
            <div className="relative">
              <div className="absolute inset-y-0 start-0 flex items-center pl-4 pointer-events-none">
                <MdSearch />
              </div>
              <input type="text" value={filterText} onChange={(e) => setFilterText(e.target.value)} className="w-full sm:w-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm sm:text-md rounded-full focus:ring-blue-500 focus:border-blue-500 block pl-8 p-2.5" placeholder="Search"/>
            </div>
          </form>
        </div>
      </div>
      <div className="border rounded-3xl">
        <DataTable
          data={filteredData}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationComponent={CustomPagination}
          customStyles={customStyles}
          progressPending={loading}
          progressComponent={<SkeletonTable rows={5} columns={6} />}
          highlightOnHover
          striped
          onRowClicked={(row) => {
            if (row.class?._id) {
              history.push({
                pathname: `/t/subjects/notes/${row._id}/${row.class._id}`, 
                state: { subject: row }
              });
            }
          }}
          pointerOnHover
        />
      </div>
    </div>
    </>
  );
};
export default TeacherSubjects;
